import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as EcommercePerformanceReportNetSalesAction from '../actions/ecommerce-performance-net-sales.action';
import * as EcommercePerformanceReportNetSalesLastYearAction from '../actions/ecommerce-performance-net-sales-last-year.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap} from 'rxjs/operators';
import {LoadEcommercePerformanceReportNetSales, LoadEcommercePerformanceReportNetSalesLastYear} from "../actions";
import {EcommerceService} from "../../websites/website/ecommerce/ecommerce.service";
@Injectable()
export class EcommercePerformanceReportNetSalesEffect {

  loadEcommercePerformanceReportNetSales = createEffect(() => this._actions$.pipe(
    ofType(EcommercePerformanceReportNetSalesAction.LOAD_ECOMMERCE_PERFORMANCE_REPORT_NET_SALES),
    mergeMap((action: LoadEcommercePerformanceReportNetSales) => {
      const {websiteId} = action.payload;
      const datePicker = action?.payload?.datePicker;
      const forceCharge = action?.payload?.forceCharge;
      return this._ecommerceService.getPerformanceReportNetSales(websiteId, datePicker, forceCharge)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success && response?.data) {
              return new EcommercePerformanceReportNetSalesAction.LoadEcommercePerformanceReportNetSalesSuccess({
                netSalesData: response?.data?.dataKey?.intervals,
                websiteId: websiteId,
                loaded: true
              });
            }
            return new EcommercePerformanceReportNetSalesAction.LoadEcommercePerformanceReportNetSalesFail({websiteId});
          })
        );
    })
  ));

  loadEcommercePerformanceReportNetSalesLastYear = createEffect(() => this._actions$.pipe(
    ofType(EcommercePerformanceReportNetSalesLastYearAction.LOAD_ECOMMERCE_PERFORMANCE_REPORT_NET_SALES_LAST_YEAR),
    mergeMap((action: LoadEcommercePerformanceReportNetSalesLastYear) => {
      const {websiteId} = action.payload;
      const datePicker = action?.payload?.datePicker;
      const forceCharge = action?.payload?.forceCharge;
      return this._ecommerceService.getPerformanceReportNetSales(websiteId, datePicker, forceCharge)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success && response?.data) {
              return new EcommercePerformanceReportNetSalesLastYearAction.LoadEcommercePerformanceReportNetSalesLastYearSuccess({
                netSalesDataLastYear: response?.data?.dataKey?.intervals,
                websiteId: websiteId,
                loaded: true
              });
            }
            return new EcommercePerformanceReportNetSalesLastYearAction.LoadEcommercePerformanceReportNetSalesLastYearFail({websiteId});
          })
        );
    })
  ));


  constructor(
    private _actions$: Actions,
    private _ecommerceService: EcommerceService,
  ) {
  }

}
